import { INPUT_DELAY_TICKS } from '../sim/constants';
import type { Command, CommandDraft } from '../sim/commands';

/*
 * מקור פקודות.
 *
 * **זו כל האבסטרקציה שצריך כדי לא לחסום מולטיפלייר.** הלולאה מנקזת מקורות פקודות
 * ואינה יודעת מאיפה הן הגיעו; הוספת רשת בעתיד היא מימוש שלישי של הממשק הזה, בלי
 * לגעת בסימולציה.
 *
 * **השהיית הקלט פעילה כבר בשחקן יחיד, בכוונה.** פקודה נחתמת לטיק עתידי במקום
 * להתבצע מיד, כך שנתיב תזמון הפקודות הוא בדיוק זה שהרשת תצטרך — ולא נגלה את
 * ההבדל רק כשנחבר שחקן שני. משוב ויזואלי מיידי (סימון בחירה, סמן) אינו עובר כאן.
 */

export interface CommandSource {
    /** מוציא את הפקודות שמיועדות לטיק הזה ומסיר אותן מהתור. */
    drain(tick: number): Command[];
    /** האם המקור מוכן לטיק הזה. מקומי תמיד מוכן; רשת תמתין לפקודות היריב. */
    ready(tick: number): boolean;
}

export class LocalCommandSource implements CommandSource {
    private readonly pending: Command[] = [];
    private seq = 0;

    constructor(private readonly player: number) {}

    /** מוסיף פקודה שתתבצע בטיק עתידי. מחזיר את הטיק שנקבע לה. */
    issue(command: CommandDraft, currentTick: number): number {
        const tick = currentTick + INPUT_DELAY_TICKS;
        this.pending.push({
            ...command,
            tick,
            player: this.player,
            seq: this.seq++,
        } as Command);
        return tick;
    }

    drain(tick: number): Command[] {
        /*
         * סריקה קדימה ובנייה מחדש, ולא splice תוך כדי סריקה אחורה: הגרסה ההיא
         * החזירה את הפקודות בסדר הפוך. הסימולציה ממיינת בכל מקרה, אבל מקור שמחזיר
         * סדר הפוך הוא מלכודת למי שיצרוך אותו בלי למיין — ובראשם מקור הרשת העתידי.
         */
        const ready: Command[] = [];
        const keep: Command[] = [];
        for (const command of this.pending) {
            if (command.tick <= tick) {
                // פקודה שאיחרה נדחפת לטיק הנוכחי במקום להיזרק — עדיף מאוחר מלעולם לא.
                ready.push(command.tick === tick ? command : { ...command, tick });
            } else {
                keep.push(command);
            }
        }
        this.pending.length = 0;
        this.pending.push(...keep);
        return ready;
    }

    ready(): boolean {
        return true;
    }
}

/*
 * המימוש השלישי — `net/NetworkCommandSource` — יושב ב-`src/net/` ולא כאן, כי הוא
 * גורר איתו את הפרוטוקול ואת התעבורה. הוא נכנס בדיוק לתוך הממשק שלמעלה, וזה כל
 * מה שהאבסטרקציה הזו נועדה להבטיח.
 */
